import React from "react";
import { Modal } from "antd";

export const PDF_COLUMN_LIMIT = 7;

function PdfColumnLimitModal({
  open,
  showColumnLimitNotice = false,
  showExcelOption = true,
  onCancel,
  onProceed,
  onDownloadCsv,
}) {
  return (
    <Modal
      centered
      getContainer={document.body}
      open={open}
      onCancel={onCancel}
      footer={null}
      title={null}
      width={500}
      className="pdf-column-limit-modal"
      closable
      maskClosable
    >
      <h3 className="pdf-limit-title">
        {showColumnLimitNotice
          ? "PDF column limit warning"
          : showExcelOption
          ? "Export as PDF"
          : "Exporting may take some time"}
      </h3>
      {showColumnLimitNotice ? (
        <>
          <p className="pdf-limit-desc">
            Due to PDF wrapping of data to fit a page, PDF downloads may not include
            all columns. The number of columns in the file can change depending on
            the report data.
          </p>
          <p className="pdf-limit-desc">
            You can proceed with a PDF download or download the report as Excel.
          </p>
        </>
      ) : (
        <p className="pdf-limit-desc">
          Please wait while we prepare your file.
        </p>
      )}
      <div className="pdf-limit-actions">
        {showExcelOption && (
          <button type="button" className="pdf-limit-btn secondary" onClick={onDownloadCsv}>
            Download as Excel
          </button>
        )}
        <button type="button" className="pdf-limit-btn primary" onClick={onProceed}>
          Proceed
        </button>
      </div>
    </Modal>
  );
}

export default PdfColumnLimitModal;
